import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { Spinner } from "../common/Spinner";
import { buildLoginRedirectPath } from "./loginRedirect";

function RequireAuth({ children }) {
  const { session, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Spinner />;
  }

  if (!session || !user) {
    return <Navigate to={buildLoginRedirectPath(location)} replace />;
  }

  return children ?? <Outlet />;
}

export { RequireAuth };
